import React from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  Stack,
  Divider,
  useTheme,
} from "@mui/material";
import ImageOrderingEditor, {
  ImageOrderingValue,
} from "../ImageOrderingEditor";
import SyndicatorCard from "../SyndicatorCard";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

export const dealersCircleDefaults = {
  syndicatorData: {
    dealersCircleEnvironment: "",
    dealersCircleId: "",
  },
  imageOrdering: {
    ImageOrder: "",
  },
};

const DealersCircleForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const accent = theme.palette.status.accent;

  const syndicatorData = config.syndicatorData || {};
  const imageOrdering: ImageOrderingValue = config.imageOrdering || {};

  return (
    <SyndicatorCard title="Dealers Circle Configuration">
      <Stack spacing={3}>
        <Box>
          <Typography
            variant="subtitle2"
            sx={{ mb: 1.5, color: accent, fontWeight: 600 }}
          >
            Syndicator Data
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Environment"
                fullWidth
                size="small"
                placeholder="qa | prod"
                value={syndicatorData.dealersCircleEnvironment || ""}
                onChange={(e) =>
                  onChange(
                    "syndicatorData.dealersCircleEnvironment",
                    e.target.value,
                  )
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Dealers Circle ID"
                fullWidth
                size="small"
                value={syndicatorData.dealersCircleId || ""}
                onChange={(e) =>
                  onChange("syndicatorData.dealersCircleId", e.target.value)
                }
              />
            </Grid>
          </Grid>
        </Box>

        <Divider />

        <Box>
          <Typography
            variant="subtitle2"
            sx={{ mb: 1.5, color: accent, fontWeight: 600 }}
          >
            Image Ordering
          </Typography>
          <ImageOrderingEditor
            value={imageOrdering}
            onChange={(next) => onChange("imageOrdering", next)}
          />
        </Box>
      </Stack>
    </SyndicatorCard>
  );
};

export default DealersCircleForm;
